<template>
  <section class="section">
    <!-- <LinkovaniLogotipovi /> -->
    <div class="container" v-if="inProgress">
      <h1 class="title">Провера стстуса у току ...</h1>
    </div>
    <div class="container" v-else>
      <h1 class="title">Подаци о трансакцији</h1>
      <div class="box">
        <!-- <h3 class="is-size-5">Статус:<br />{{ status }}</h3>
        <h3 class="is-size-5">Број поруџбине:<br />{{ broj_porudzbine }}</h3>
        <h3 class="is-size-5">Износ и валута:<br />{{ iznos }} {{ valuta }}</h3>
        <h3 class="is-size-5">Тип картица:<br />{{ tip_kartice }}</h3>
        <h3 class="is-size-5">Време трансакције:<br />{{ vreme_transakcije }}</h3> -->

        <div class="columns">
          <div class="column is-one-quarter">
            <span class="has-text-weight-bold">Статус:</span>
          </div>
          <div class="column">{{ status }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-quarter">
            <span class="has-text-weight-bold">Број поруџбине:</span>
          </div>
          <div class="column">{{ broj_porudzbine }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-quarter">
            <span class="has-text-weight-bold">Износ и валута:</span>
          </div>
          <div class="column">{{ iznos }} {{ valuta }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-quarter">
            <span class="has-text-weight-bold">Тип картице:</span>
          </div>
          <div class="column">{{ tip_kartice }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-quarter">
            <span class="has-text-weight-bold">Време трансакције:</span>
          </div>
          <div class="column">{{ vreme_transakcije }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-quarter">
            <span class="has-text-weight-bold">Ауторизациони код банке:</span>
          </div>
          <div class="column">{{ auth_kod_banke }}</div>
        </div>
        <div class="columns">
          <div class="column">
            <b-button
              type="is-info"
              class="is-pulled-right"
              tag="router-link"
              to="/"
              >Назад</b-button
            >
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
// import LinkovaniLogotipovi from '@/components/LinkovaniLogotipovi.vue'
import Footer from '@/components/Footer.vue'
import PaymentService from '../services/PlacanjeService'

export default {
  components: {
    // LinkovaniLogotipovi,
    Footer
  },
  props: ['narudzbina'],
  data() {
    return {
      inProgress: true,
      status: '',
      broj_porudzbine: '',
      iznos: '',
      valuta: '',
      tip_kartice: '',
      // autorizacioni_kod_banke: '',
      vreme_transakcije: '',
      auth_kod_banke: ''
    }
  },
  // created() {
  //   console.log('created')
  // },
  mounted() {
    // debugger
    if (this.narudzbina) {
      this.inProgress = false
      this.prikaziPodatkeNadudzbine(this.narudzbina)
    } else {
      let checkoutId = this.$route.query.checkoutId
      if (checkoutId) {
        // this.getPaymentStatus(checkoutId)
        this.dajStatusNarudzbine(checkoutId)
      } else {
        this.inProgress = false
        console.log(this.$route.query)
      }
    }
  },
  methods: {
    dajStatusNarudzbine(checkoutId) {
      PaymentService.dajStatusNarudzbine(checkoutId)
        .then(response => {
          console.log(response.data)
          this.inProgress = false

          let narudzbina = response.data.podaci.narudzbina
          this.prikaziPodatkeNadudzbine(narudzbina)
        })
        .catch(error => {
          console.log(error)
          this.status = 'Дошло је до грешке!'
        })
    },
    prikaziPodatkeNadudzbine(narudzbina) {
      var resultCode = narudzbina.status_placanja

      if (resultCode) {
        if (resultCode.match(/^(000\.000\.|000\.100\.1|000\.[36])/)) {
          this.status = 'Трансакција је извршена успешно'
        } else if (resultCode.match(/^(000\.400\.0[^3]|000\.400\.100)/)) {
          this.status =
            'Трансакција је извршена успешно (' +
            narudzbina.status_placanja_opis +
            ')'
        } else if (resultCode.match(/^(000\.200)/)) {
          this.status =
            'Трансакција на чекању (' + narudzbina.status_placanja_opis + ')'
        } else if (resultCode.match(/^(800\.400\.5|100\.400\.500)/)) {
          this.status =
            'Трансакција на чекању (' + narudzbina.status_placanja_opis + ')'
        } else {
          this.status =
            'Трансакција је одбијена (' + narudzbina.status_placanja_opis + ')'
        }
      }

      this.broj_porudzbine = narudzbina.id
      this.iznos = narudzbina.iznos
      this.valuta = narudzbina.valuta
      this.tip_kartice = narudzbina.tip_kartice
      this.vreme_transakcije = narudzbina.vreme_transakcije
      if (narudzbina.auth_kod_banke) {
        this.auth_kod_banke = narudzbina.auth_kod_banke
      }

      if (narudzbina.email_poslat === 'Da') {
        this.$buefy.snackbar.open(
          'Статус је послати на адресу електронске поште'
        )
      } else {
        this.$buefy.snackbar.open({
          message: 'Статус није послати на адресу електронске поште!',
          type: 'is-danger'
        })
      }
    }
  }
}
</script>

<style>
.margina {
  margin-bottom: 16px;
}
</style>
